import { isMobile } from '../base'

function createHeaderIcons() {
    const navigationButtons = $('.navigation-buttons')
    $('.top-navigation-tools .top-nav-button').prependTo(navigationButtons)
}
function moveCartWidget() {
    const widgetsClones = $('.user-action-in')
    widgetsClones.appendTo('.header-top-wrapper')
}

function changeLangNameToFlag() {
    const lang = $('html').attr('lang');
    if (!lang) return;

    const map = { en: 'GB', cs: 'CZ' };
    const code = map[lang] || lang.toUpperCase();

    const $langSelect = $('.languagesMenu__box .languagesMenu__header--actual');

    // zmena ro flagu na hr v lang menu

    if ($langSelect.length) {
        const $caret = $langSelect.find('.caret').detach();
        let $flag;

        if (lang === 'ro') {

            $flag = $('<img>', {
                src: '/user/documents/able-images/hr.png',
                alt: 'Hrvatska',
                class: 'shp-flag shp-flag-HR',
                width: 24,
                height: 16
            });
        } else {
            $flag = $(`.languagesMenu__list__link[href*="language=${lang}"] svg`).clone();
        }

        $langSelect.empty().append($flag).append($caret);
    }

    // zmena ro flagu na hr v lang dropdown

    // const $langRo = $('.languagesMenu__list__link[href*="language=ro"]');
    // if ($langRo.length) {
    //
    //     $langRo
    //         .find('svg.shp-flag')
    //         .replaceWith(
    //             $('<img>', {
    //                 src: '/user/documents/able-images/hr.png',
    //                 alt: 'Hrvatska',
    //                 class: 'shp-flag shp-flag-HR',
    //                 width: 24,
    //                 height: 16
    //             })
    //         );
    //
    //     $langRo
    //         .find('.languagesMenu__list__name')
    //         .text('Hrvatski')
    //         .addClass('languagesMenu__list__name--actual');
    // }

    // const $flag = $('<img>', {
    //     src: '/user/documents/able-images/hr.png',
    //     alt: 'Hrvatska',
    //     class: 'shp-flag shp-flag-HR',
    //     width: 24,
    //     height: 16
    // });
    //
    // $('#navigation .navigationActions .ext .navigationActions__link--flag')
    //     .find('svg.shp-flag.shp-flag-RO')
    //     .each(function () { $(this).replaceWith($flag.clone()); });
    //
    // $('#navigation .navigationActions .ext > a .navigationActions__flagWrapper')
    //     .find('svg.shp-flag.shp-flag-RO')
    //     .each(function () { $(this).replaceWith($flag.clone()); });
}

function moveLanguageSelectAndChangeLang() {
    $('.languagesMenu').prependTo('.navigation-buttons')
    // $('.languagesMenu__list__link[href*="language=ro"]').find('.languagesMenu__list__name').text('Hrvatski')

    changeLangNameToFlag()
}

// obecná funkce, která shromažďuje všechny funkce, které elementy do hlavičky přidávají nebo někam přesunují
function moveAddHeaderElements() {
    createHeaderIcons()
    moveCartWidget()
    moveLanguageSelectAndChangeLang()

    $('.site-msg').insertBefore('.top-navigation-bar')
}
// Přidá třídu scrolled do body, pokud je uživatel scrolluje pro fungování fixní hlavičky
function addScrolledClass() {
    const mobileElements = [$('.site-msg.information')]

    const desktopElements = [$('.header-top'), $('.admin-bar'), $('.site-msg.information')]

    $(window).on('scroll', function () {
        const elements = isMobile() ? mobileElements : desktopElements

        const threshold = elements.reduce((sum, el) => {
            return sum + (el.is(':visible') ? el.outerHeight() || 0 : 0)
        }, 0)

        $('body').toggleClass('scrolled', $(this).scrollTop() > threshold)
    })
}

function addScrollDirectionClass() {
    let lastScrollTop = 0
    const body = $('body')

    $(document).on('scroll', function () {
        const scrollTop = $(document).scrollTop()

        if (scrollTop > lastScrollTop) {
            body.removeClass('scrolled-up').addClass('scrolled-down')
        } else {
            body.removeClass('scrolled-down').addClass('scrolled-up')
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
    })
}

function topNavigation() {
    $('.header-top .site-name').append(
        $(`<div class="site-badge"><span class="icon-medal"></span>Authorized Sea-Doo dealer</div>`)
    )
}

function setSiteMsgHeightVar() {
    const siteMsgElement = $('.site-msg.information')
    const siteMsgHeight = siteMsgElement.length ? siteMsgElement.outerHeight() : 0

    document.documentElement.style.setProperty('--site-msg-height', `${siteMsgHeight}px`)

    $('.js-close-information-msg').on('click', function () {
        document.documentElement.style.setProperty('--site-msg-height', `0px`)
    })
}

export function initHeader() {
    shoptet.config.mobileHeaderVersion = '0'
    moveAddHeaderElements()
    addScrolledClass()
    addScrollDirectionClass()
    topNavigation()
    setSiteMsgHeightVar()

    document.addEventListener('resizeEnd', () => {
        setSiteMsgHeightVar()
    })
}
